const generateTooltipForCreateButton = (
  serviceName: string,
  isWorkspaceSelectionRequired: boolean
) => {
  if (!serviceName.length && isWorkspaceSelectionRequired) {
    return 'Service account name and authorized workspace selection are required';
  } else if (!serviceName.length) {
    return 'Service account name is required';
  } else if (isWorkspaceSelectionRequired) {
    return 'Authorized workspace must be selected';
  }
  return '';
};

export default generateTooltipForCreateButton;
